module.exports = __webpack_public_path__ + "img/terracenew_box16.9db6ff17.jpg";